import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Panel, Overline, Btn, Pill, Icon, PageLoader } from "../../components/ui-kit";
import { cn } from "../../lib/utils";

const CONF = {
  high: { label: "High Probability", grad: "linear-gradient(135deg,#f08a8a,#e05555)", color: "#EF6B6B", icon: "Flame", tone: "coral" },
  medium: { label: "Likely", grad: "linear-gradient(135deg,#f7c65e,#e09a1f)", color: "#F3B83F", icon: "TrendingUp", tone: "yellow" },
  likely: { label: "Worth Reviewing", grad: "linear-gradient(135deg,#33c7e2,#0f97b3)", color: "#19B9D8", icon: "Target", tone: "cyan" },
};

export default function ExamRadarPage() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/student/exam-radar").then(({ data }) => setD(data)); }, []);
  if (!d) return <PageLoader />;
  const groups = ["high", "medium", "likely"].map((lvl) => ({ lvl, items: d.items.filter((i) => i.priority === lvl) }));

  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6 space-y-6">
      <div className="relative rounded-[28px] p-6 sm:p-7 text-white overflow-hidden" style={{ background: "linear-gradient(135deg,#f08a8a,#d94848)" }}>
        <div className="absolute inset-0 dotgrid opacity-50" />
        <Icon name="Radar" className="absolute -right-4 -bottom-5 w-36 h-36 opacity-15" />
        <div className="relative">
          <Overline className="text-white/80">Exam Radar</Overline>
          <h1 className="text-3xl sm:text-4xl font-bold mt-1 tracking-tight">What to study for your exam</h1>
          <p className="text-white/80 text-sm mt-2 max-w-xl">{d.note}</p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3">
        {groups.map(({ lvl, items }) => (
          <div key={lvl} className="rounded-2xl p-4 text-white text-center" style={{ background: CONF[lvl].grad }}>
            <Icon name={CONF[lvl].icon} className="w-5 h-5 mx-auto" />
            <div className="text-2xl font-bold mt-1">{items.length}</div>
            <div className="text-[10px] font-semibold uppercase tracking-wide text-white/80">{CONF[lvl].label}</div>
          </div>
        ))}
      </div>

      {groups.map(({ lvl, items }) => items.length > 0 && (
        <div key={lvl}>
          <div className="flex items-center gap-2 mb-3"><Icon name={CONF[lvl].icon} className="w-4 h-4" style={{ color: CONF[lvl].color }} /><h3 className="font-bold text-mim-navy">{CONF[lvl].label}</h3></div>
          <div className="space-y-3">
            {items.map((it) => (
              <Panel key={it.topic_id} className="border-l-4" style={{ borderLeftColor: CONF[lvl].color }}>
                <div className="flex items-center gap-2 flex-wrap"><h4 className="font-bold text-mim-navy">{it.name}</h4><span className="text-xs font-semibold" style={{ color: it.subject_color }}>{it.subject_name}</span></div>
                <p className="text-xs text-mim-muted mt-1"><span className="font-semibold text-mim-navy">Why: </span>{it.reason}</p>
                <div className="flex items-center gap-3 mt-2 text-xs text-mim-muted"><span className="inline-flex items-center gap-1"><Icon name="Scale" className="w-3.5 h-3.5" />Weightage {it.weightage}/5</span><span className="inline-flex items-center gap-1"><Icon name="Award" className="w-3.5 h-3.5" />Mastery {it.mastery}%</span></div>
                <div className="flex gap-2 mt-3">
                  <Link to={`/topic/${it.topic_id}`} className="flex-1"><Btn variant="secondary" className="w-full" icon="Dumbbell">Practice</Btn></Link>
                  <Link to={`/topic/${it.topic_id}`} className="flex-1"><Btn className="w-full" icon="CircleHelp">Take Quiz</Btn></Link>
                </div>
              </Panel>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
